import React, { useState } from 'react';
import { FaCalculator } from 'react-icons/fa';
import './DrillingCalculator.css';

const currencyFormatter = new Intl.NumberFormat('en-NG', {
  style: 'currency',
  currency: 'NGN',
  maximumFractionDigits: 2
});

function DrillingCalculator() {
  const [measurements, setMeasurements] = useState({
    length: '',
    width: '',
    averageDepth: '',
    rate: ''
  });

  const handleChange = event => {
    const { name, value } = event.target;
    setMeasurements(current => ({ ...current, [name]: value }));
  };

  const length = Number(measurements.length) || 0;
  const width = Number(measurements.width) || 0;
  const averageDepth = Number(measurements.averageDepth) || 0;
  const rate = Number(measurements.rate) || 0;
  const volume = length * width * averageDepth;
  const totalAmount = volume * rate;
  const hasVolume = measurements.length && measurements.width && measurements.averageDepth;
  const hasRate = measurements.rate !== '';

  return (
    <section className="drilling-calculator" aria-labelledby="calculator-title">
      <div className="container">
        <div className="calculator-layout">
          <div className="calculator-intro">
            <p className="home-label">Project estimate</p>
            <h2 id="calculator-title">Know the scale of your ground.</h2>
            <p>Enter your project dimensions to estimate the drilling volume and cost before speaking with our team.</p>
            <div className="calculator-note">
              <FaCalculator aria-hidden="true" />
              <span>All measurements should be entered in metres. Rate is charged per cubic metre.</span>
            </div>
          </div>

          <div className="calculator-panel">
            <div className="calculator-fields">
              <label>
                Length (m)
                <input name="length" type="number" min="0" step="any" inputMode="decimal" placeholder="0.00" value={measurements.length} onChange={handleChange} />
              </label>
              <label>
                Width (m)
                <input name="width" type="number" min="0" step="any" inputMode="decimal" placeholder="0.00" value={measurements.width} onChange={handleChange} />
              </label>
              <label>
                Average Depth (m)
                <input name="averageDepth" type="number" min="0" step="any" inputMode="decimal" placeholder="0.00" value={measurements.averageDepth} onChange={handleChange} />
              </label>
              <label>
                Rate per m³ (₦)
                <input name="rate" type="number" min="0" step="any" inputMode="decimal" placeholder="0.00" value={measurements.rate} onChange={handleChange} />
              </label>
            </div>

            <div className="calculator-results" aria-live="polite">
              <div className="calculator-result">
                <span>Total volume</span>
                <strong>{hasVolume ? `${volume.toLocaleString('en-NG', { maximumFractionDigits: 2 })} m³` : '—'}</strong>
              </div>
              <div className="calculator-result calculator-total">
                <span>Estimated amount due</span>
                <strong>{hasVolume && hasRate ? currencyFormatter.format(totalAmount) : '—'}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DrillingCalculator;